module.exports = __webpack_public_path__ + "img/are4n-qukrv.a3babc42.png";